import script from "./TaskPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskPage.vue?vue&type=script&setup=true&lang=ts"

import "./TaskPage.vue?vue&type=style&index=0&id=1cb20482&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb20482"]])

export default __exports__